/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Unexpectederrorchunk12Inputs */

const en_errors_unexpectederrorchunk12 = /** @type {(inputs: Errors_Unexpectederrorchunk12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We encountered an error, please try again later or`)
};

/**
* | output |
* | --- |
* | "We encountered an error, please try again later or" |
*
* @param {Errors_Unexpectederrorchunk12Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_unexpectederrorchunk12 = /** @type {((inputs?: Errors_Unexpectederrorchunk12Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Unexpectederrorchunk12Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_unexpectederrorchunk12(inputs)
});
export { errors_unexpectederrorchunk12 as "errors_unexpectedErrorChunk1" }